module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//tiger_5_1.png?v=37078885";